enum portals {
	residence = 'residence',
	campus = 'campus'
}

export default portals
